
import {
  computed,
  defineComponent,
  PropType,
  ref,
  shallowRef,
} from 'vue'
import dayjs from 'dayjs'
import NlpCard from '@/views/NLP/components/NlpCard.vue'
import VisualGraph from '@/views/NLP/components/VisualGraph.vue'
import { saveAs } from 'file-saver'
import { IFileRead } from '@/api/nlp/nlp-api-type'

export default defineComponent({
  name: 'GraphCard',
  components: {VisualGraph, NlpCard },
  props: {
    graphData: {
      type: Object as PropType<IFileRead.NlpGraphRes>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true
    },
  },
  setup(props, { emit }) {
    // const zoomScale = ref('100%')
    // const validScaleList = [
    //   100,
    //   110,
    //   125,
    //   150,
    //   175,
    //   200,
    //   250,
    //   300,
    //   400,
    //   500,
    // ]
    // const minScale = validScaleList[0]
    // const maxScale = validScaleList[validScaleList.length - 1]
    // function zoomChange (mode: 'plus' | 'minus') {
    //   const scaleNumber = Number(zoomScale.value.replace('%', ''))
    //   let nextScale: number = scaleNumber
    //
    //   for (let i = 0; i < validScaleList.length; i++) {
    //     if (scaleNumber ===  validScaleList[i]) {
    //       if (validScaleList[i] === minScale) {
    //         nextScale = mode === 'plus' ? validScaleList[i + 1] : minScale
    //       } else if (validScaleList[i] === maxScale) {
    //         nextScale = mode === 'plus' ? maxScale : validScaleList[i - 1]
    //       } else {
    //         nextScale = mode === 'plus' ? validScaleList[i + 1] : validScaleList[i - 1]
    //       }
    //       break
    //     } else if (scaleNumber >  validScaleList[i] && scaleNumber < validScaleList[i + 1]) {
    //       nextScale = mode === 'plus' ? validScaleList[i + 1] : validScaleList[i - 1]
    //       break
    //     }
    //   }
    //   console.log('**debug zoomChange scaleNumber:', scaleNumber)
    //   console.log('**debug zoomChange nextScale:', nextScale)
    //   zoomScale.value = `${nextScale}%`
    // }
    //
    // function handleInputZoomScale (val: string) {
    //   zoomScale.value = val
    // }
    //
    // watch(zoomScale, v => {
    //   const scaleNumber = Number(zoomScale.value.replace('%', ''))
    // })

    // const graphData = ref({
    //   nodes: [
    //     { id: '1', label: '刘备', type: '男', properties: { age: 50 } },
    //     { id: '2', label: '关羽', type: '男' },
    //     { id: '3', label: '张飞', type: '男' },
    //     { id: '4', label: '孙权', type: '男' },
    //     { id: '5', label: '曹操', type: '男' },
    //   ],
    //   links: [
    //     { source: '1', target: '2', label: '二弟', properties: { other: 'other prop' } },
    //     { source: '1', target: '3', label: '三弟' },
    //     { source: '4', target: '5', label: '对手' }
    //   ]
    // })

    const graphRef = shallowRef<InstanceType<typeof VisualGraph>>()
    function zoomChange (mode: 'plus' | 'minus') {
      console.log('**zoomChange mode:', mode)
      if (mode === 'plus') {
        graphRef.value?.zoomOut()
      } else {
        graphRef.value?.zoomIn()
      }
    }

    const isImgDownloading = ref(false)
    function exportImg () {
      if (graphRef.value) {
        isImgDownloading.value = true
        const dataURL = graphRef.value.exportImageDataURL()
        fetch(dataURL)
          .then(res => res.blob())
          .then((blob) => {
            if (blob) {
              saveAs(blob, `知识图谱-${dayjs().format('YYYYMMDDHHmmss')}.jpg`,)
            }
          })
          .finally(() => {
            isImgDownloading.value = false
          })
      }
    }

    const hasData = computed(() => {
      try {
        return props.graphData.nodes.length > 0 || props.graphData.links.length > 0
      } catch (e) {
        return false
      }
    })

    const isExportBtnDisabled = computed(() => {
      return !hasData.value || props.loading
    })

    return {
      graphRef,
      isImgDownloading,
      exportImg,
      zoomChange,

      hasData,
      isExportBtnDisabled,
    }
  },
})
